// @flow

const QUICK_PROMOTE_COUNTRIES = [
  'AU',
  'CA',
  'GB',
  'IE',
  'NZ',
  'US',
  'FR',
  'DE',
  'AT',
  'IT',
  'ES',
  'NL',
  'BE',
  'PT',
  'CH',
];

const ADS_ELIGIBLE_COUNTRIES = [
  'US',
  'GB',
  'IE',
  'NZ',
  'AU',
  'CA',
  'FR',
  'DE',
  'AT',
  'IT',
  'ES',
  'NL',
  'BE',
  'PT',
  'CH',
  'DK',
  'SE',
  'NO',
  'FI',
];

export const countryIsEligibleForQuickPromote = (
  country: string, // NOTE: add any experimental country activations here  @jlumarie
) => QUICK_PROMOTE_COUNTRIES.includes(country.toUpperCase());

export const countryIsEligibleForAds = (country: string) =>
  ADS_ELIGIBLE_COUNTRIES.includes(country.toUpperCase());

// The following types and helper functions were created for use on the Business Hub page,
// but are easily extensible and can be reused elsewhere.
export type DailyMetrics = {
  [key: string]: Array<?number>,
};

export type AggregatedTrendAndTotal = {
  numDays: number,
  [key: string]: {
    total: number,
    trend: number,
  },
};

// sum an array of number / nulls, defaulting falsy values (null, undefined etc.) to 0.
export const sum = (values: Array<?number>) =>
  values.reduce((a: ?number, b: ?number) => (a || 0) + (b || 0), 0);

export const calculateXDayTrendAndTotal = (
  dailyMetrics: DailyMetrics,
  columnsToAggregate: Array<string>,
  numDays: number,
): AggregatedTrendAndTotal => {
  const aggregatedMetrics = { numDays };

  columnsToAggregate.forEach((key) => {
    // In order to calculate trend, we need data for 2x the number of days requested
    if (dailyMetrics[key].length >= numDays * 2) {
      const lastXDaysTotal = sum(dailyMetrics[key].slice(0, numDays));
      const thisXDaysTotal = sum(dailyMetrics[key].slice(numDays, numDays * 2));

      aggregatedMetrics[key] = {
        total: thisXDaysTotal,
        trend: lastXDaysTotal ? (thisXDaysTotal - lastXDaysTotal) / lastXDaysTotal : 0,
      };
    }
  });

  return aggregatedMetrics;
};

export default null;
